import { cn } from "@/lib/utils";

type ParticipantSectionHeadingProps = {
  id?: string;
  title: string;
  description?: string;
  className?: string;
};

export default function ParticipantSectionHeading({
  id,
  title,
  description,
  className,
}: ParticipantSectionHeadingProps) {
  return (
    <div className={cn("grid gap-[0.35rem]", className)}>
      <h2 className={"type-section-title"} id={id}>
        {title}
      </h2>
      {description ? (
        <p className={"type-section-body"}>
          {description}
        </p>
      ) : null}
    </div>
  );
}
